import bugsnag from "bugsnag-js";

let s = false;

const showWarning = (): void => {
    if (!s) {
        console.log(
            "%cStop!",
            "font: 4em sans-serif; color: white; background-color: red;"
        );
        console.log(
            "%cThis is a browser feature intended for developers.",
            "font: 2em sans-serif"
        );
        console.log(
            "%cIf someone told you to copy-paste something here to enable a GGS feature or 'hack' someone's account, it is a scam and will give them access to your account.",
            "font: 2em sans-serif"
        );
        console.log(
            "Are you a developer? We’re hiring! http://bit.ly/see-jobs-at-goodgames"
        );

        s = true;
    }
};

const setupConsole = (stage: string): void => {
    if (stage !== "production") {
        return;
    }

    Object.defineProperty(window, "console", {
        value: console,
        writable: false,
        configurable: false
    });

    let l, n = {
        set: function(o) {
            l = o;
        },
        get: function() {
            showWarning();
            return l;
        }
    };

    Object.defineProperty(console, "_commandLineAPI", n);
    Object.defineProperty(console, "__commandLineAPI", n);

    if ((<any>console)._commandLineAPI) {
        (<any>console)._commandLineAPI();
    }

    if ((<any>console).__commandLineAPI) {
        (<any>console).__commandLineAPI();
    }
};

const supressConsole = (stage: string): void => {
    if (stage !== "production") {
        return;
    }

    let methods = ["log", "debug", "info", "warn", "error"];

    methods.forEach((method) => {
        console[method] = () => {
        };
    });
};

const setupBugsnag = (appVersion: string, stage: string): void => {
    (<any>window).bugsnagClient = bugsnag({
        apiKey: "66a733a9d9ca2587320112043016ed0e",
        appVersion: appVersion,
        collectUserIp: false,
        notifyReleaseStages: ["development", "qa", "preproduction", "production"],
        releaseStage: stage,
        beforeSend: function(report) {
            let step: string = "no_tracking_info_available";

            report.metaData = { "gameplay": { "last_funnel_step": step } };
        }
    });
};

/**
 * Edge fix required for compatibility with GGS logger, see below log message.
 */
const applyEdgeFix = (): void => {
    (function(window) {
        //is Edge
        if (!!(<any>window).StyleMedia) {
            if (window.location.href.indexOf('debugedge') != -1) {
                console.log('Edge logging enabled');
                return;
            }
            if (
                typeof window.console === 'object' ||
                typeof (<any>window.console).log === 'function'
            ) {
                console.log('logging disabled by default for Edge as with the certain dev setups and console closed it fails, to enable logging add "debugedge" to the querystring load the page (it will fail) open the console and reload, with the console object now created it will work');
                var method;
                var noop = function noop() {
                };
                var methods = ['show', 'hide', 'clear', 'log', 'debug', 'dir', 'info', 'warn', 'error'];
                var length = methods.length;
                while (length--) {
                    method = methods[length];
                    console[method] = noop;
                }
            }
        }
    }(window));
};

const detectStage = (): string => {
    return window.location.hostname.search("localhost") !== -1
        ? "development"
        : window.location.hostname.search("test") === -1
            ? "production"
            : (window.location.pathname.split("/")[1] || "unknown");
};

const initPageIntegrationMessageHandler = (stage) => {
    const domains = ["message-handler 1.3.0 allows everything"];
    console.log("Initialize PageIntegration cross-communication registering MessageHandler with allowed domains");
    (<any>window).messageHandler = new (<any>window).MessageHandler(
        new (<any>window).EventHandler(),
        domains,
        window.parent,
        (window.location != window.parent.location) ? document.referrer : document.location.href
    );
    (<any>window).messageHandler.register();
};

export const wrapper = (appVersion: string): void => {
    let stage: string = detectStage();
    setupConsole(stage);
    supressConsole(stage);
    setupBugsnag(appVersion, stage);
    applyEdgeFix();
    initPageIntegrationMessageHandler(stage);
};
